import { render } from "./MyPopUpWindowFooter.vue?vue&type=template&id=fee47d66"
import script from "./MyPopUpWindowFooter.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindowFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__